export function MinusIcon({ color }: { color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.5C0 6.23478 0.0903058 5.98043 0.251051 5.79289C0.411797 5.60536 0.629814 5.5 0.857143 5.5H11.1429C11.3702 5.5 11.5882 5.60536 11.7489 5.79289C11.9097 5.98043 12 6.23478 12 6.5C12 6.76522 11.9097 7.01957 11.7489 7.20711C11.5882 7.39464 11.3702 7.5 11.1429 7.5H0.857143C0.629814 7.5 0.411797 7.39464 0.251051 7.20711C0.0903058 7.01957 0 6.76522 0 6.5Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
}
